module.exports = __webpack_public_path__ + "static/media/HCMM961.0190a16c.jpg";